
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'
import * as entity from '../entity'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {Response} from '../core/Response';
import {FieldModelResponse} from '../core/Response';
import {DrawingStorageDashboardData} from './DrawingStorageDashboardData';
import {FieldModelDrawingStorageDashboardData} from './DrawingStorageDashboardData';

/**
 * DrawingStorageDashboardsResponse struct
 */
class DrawingStorageDashboardsResponse extends Response {
  /**
   * Initialize struct
   * @param {!Response=} parent
   * @param {!string=} source
   * @param {!Array=} dashboards
   * @constructor
   */
  constructor (parent = new Response(), source = '', dashboards = []) {
    super()
    super.copy(parent)
    this.source = source
    this.dashboards = dashboards
  }

  /**
   * Copy struct (shallow copy)
   * @this {!DrawingStorageDashboardsResponse}
   * @param {!DrawingStorageDashboardsResponse} other Other struct
   * @returns {!DrawingStorageDashboardsResponse} This struct
   */
  copy (other) {
    super.copy(other)
    if (other.source != null) {
      this.source = other.source
    } else {
      this.source = null
    }
    if (other.dashboards != null) {
      this.dashboards = []
      for (let item of other.dashboards) {
        if (item != null) {
          let tempItem
          tempItem = DrawingStorageDashboardData.fromObject(item)
          this.dashboards.push(tempItem)
        } else {
          this.dashboards.push(null)
        }
      }
    } else {
      this.dashboards = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!DrawingStorageDashboardsResponse}
   * @returns {!DrawingStorageDashboardsResponse} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new DrawingStorageDashboardsResponseModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new DrawingStorageDashboardsResponseModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!DrawingStorageDashboardsResponse}
   * @param {!DrawingStorageDashboardsResponse} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof DrawingStorageDashboardsResponse)) {
      throw new TypeError('Instance of DrawingStorageDashboardsResponse is required!')
    }
    // noinspection RedundantIfStatementJS
    if (!super.eq(other)) {
      return false
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!DrawingStorageDashboardsResponse}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    let parent = super.toJSON()
    let current = {
      source: ((this.source != null) ? this.source : null),
      dashboards: ((this.dashboards != null) ? Array.from(this.dashboards, item => ((item != null) ? item : null)) : null)
    }
    return { ...parent, ...current }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return DrawingStorageDashboardsResponse.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!DrawingStorageDashboardsResponse} other Object value
   * @returns {!DrawingStorageDashboardsResponse} Created struct
   */
  static fromObject (other) {
    return new DrawingStorageDashboardsResponse().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!DrawingStorageDashboardsResponse}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return DrawingStorageDashboardsResponse.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!DrawingStorageDashboardsResponse}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 10019
  }
}

export { DrawingStorageDashboardsResponse };

/**
 * Fast Binary Encoding DrawingStorageDashboardsResponse field model
 */
class FieldModelDrawingStorageDashboardsResponse extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this._parent = new FieldModelResponse(buffer, 4 + 4)
    this.source = new fbe.FieldModelString(buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4)
    this.dashboards = new fbe.FieldModelVector(new FieldModelDrawingStorageDashboardData(buffer, this.source.fbeOffset + this.source.fbeSize), buffer, this.source.fbeOffset + this.source.fbeSize)
  }

  /**
   * Get the core.Response field model
   * @this {!FieldModelDrawingStorageDashboardsResponse}
   * @returns {!FieldModelResponse} core.Response field model
   */
  get parent () {
    return this._parent
  }

  /**
   * Get the field size
   * @this {!FieldModelDrawingStorageDashboardsResponse}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelDrawingStorageDashboardsResponse}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.parent.fbeBody - 4 - 4 + this.source.fbeSize + this.dashboards.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelDrawingStorageDashboardsResponse}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.parent.fbeExtra + this.source.fbeExtra + this.dashboards.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelDrawingStorageDashboardsResponse}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelDrawingStorageDashboardsResponse.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelDrawingStorageDashboardsResponse}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 10019
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelDrawingStorageDashboardsResponse}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelDrawingStorageDashboardsResponse}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) > fbeStructSize) {
      return true
    }
    if (!this.parent.verifyFields(fbeStructSize)) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.source.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.source.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.source.fbeSize

    if ((fbeCurrentSize + this.dashboards.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.dashboards.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.dashboards.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelDrawingStorageDashboardsResponse}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelDrawingStorageDashboardsResponse}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelDrawingStorageDashboardsResponse}
   * @param {!DrawingStorageDashboardsResponse} fbeValue Default value, defaults is new DrawingStorageDashboardsResponse()
   * @returns {!DrawingStorageDashboardsResponse} DrawingStorageDashboardsResponse value
   */
  get (fbeValue = new DrawingStorageDashboardsResponse()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelDrawingStorageDashboardsResponse}
   * @param {!DrawingStorageDashboardsResponse} fbeValue DrawingStorageDashboardsResponse value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) <= fbeStructSize) {
      this.parent.getFields(fbeValue, fbeStructSize)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.source.fbeSize) <= fbeStructSize) {
      fbeValue.source = this.source.get()
    } else {
      fbeValue.source = ''
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.source.fbeSize

    if ((fbeCurrentSize + this.dashboards.fbeSize) <= fbeStructSize) {
      this.dashboards.get(fbeValue.dashboards)
    } else {
      fbeValue.dashboards.length = 0
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.dashboards.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelDrawingStorageDashboardsResponse}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelDrawingStorageDashboardsResponse}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelDrawingStorageDashboardsResponse}
   * @param {!DrawingStorageDashboardsResponse} fbeValue DrawingStorageDashboardsResponse value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelDrawingStorageDashboardsResponse}
   * @param {DrawingStorageDashboardsResponse} fbeValue DrawingStorageDashboardsResponse value
   */
  setFields (fbeValue) {
    this.parent.setFields(fbeValue)
    this.source.set(fbeValue.source)
    this.dashboards.set(fbeValue.dashboards)
  }
}

export { FieldModelDrawingStorageDashboardsResponse };

/**
 * Fast Binary Encoding DrawingStorageDashboardsResponse model
 */
class DrawingStorageDashboardsResponseModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelDrawingStorageDashboardsResponse(this.buffer, 4)
  }

  /**
   * Get the DrawingStorageDashboardsResponse model
   * @this {!DrawingStorageDashboardsResponseModel}
   * @returns {!FieldModelDrawingStorageDashboardsResponse} model DrawingStorageDashboardsResponse model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!DrawingStorageDashboardsResponseModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!DrawingStorageDashboardsResponseModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return DrawingStorageDashboardsResponseModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!DrawingStorageDashboardsResponseModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelDrawingStorageDashboardsResponse.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!DrawingStorageDashboardsResponseModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!DrawingStorageDashboardsResponseModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!DrawingStorageDashboardsResponseModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!DrawingStorageDashboardsResponseModel}
   * @param {!DrawingStorageDashboardsResponse} value DrawingStorageDashboardsResponse value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!DrawingStorageDashboardsResponseModel}
   * @param {!DrawingStorageDashboardsResponse} value DrawingStorageDashboardsResponse value, defaults is new DrawingStorageDashboardsResponse()
   * @return {!object} Deserialized DrawingStorageDashboardsResponse value and its size
   */
  deserialize (value = new DrawingStorageDashboardsResponse()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new DrawingStorageDashboardsResponse(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new DrawingStorageDashboardsResponse(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!DrawingStorageDashboardsResponseModel}
   * @param {!number} prev Previous DrawingStorageDashboardsResponse model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { DrawingStorageDashboardsResponseModel };
